import {connect} from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import {Field, reduxForm, initialize} from 'redux-form'
import FormInput from 'components/FormInput'
import Loader from 'components/Loader'
import Submit from './Submit'

export class Mappings extends React.Component {
  static propTypes = {
    site: PropTypes.object,
    submitButtonText: PropTypes.string,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    handleSubmit: PropTypes.func,
    initialize: PropTypes.func,
    onSkip: PropTypes.func,
    formValues: PropTypes.object
  }

  componentDidMount() {
    const {formValues, initialize} = this.props

    if (formValues && formValues.mappings) {
      initialize(formValues.mappings)
    }
  }

  render() {
    const {handleSubmit, invalid, submitting, submitButtonText, site, onSkip} = this.props

    if (!site) {
      return (
        <div className='mappings-step'>
          <Loader />
        </div>
      )
    }

    const {domain} = site

    return (
      <form className='mappings-step' onSubmit={handleSubmit}>
        <div className='mappings-step_input'>
          <span className='mappings-step_input_prefix'>
            {domain}
          </span>
          <Field
            className='mappings-step_input_field'
            name='mapping'
            placeholder='checkout.html'
            disabled={submitting}
            component={FormInput}
          />
        </div>
        <p>
          Please add the URL of your checkout page after your domain name.
          If you have a dynamic checkout url, replace all dynamic parts with <strong>*</strong><br />
        </p>
        <p>
          Example: <em>www.yourdomain.com/checkout</em> - You only need to enter: <strong>/checkout</strong>.
        </p>
        <p>
          Example: <em>www.yourdomain.com/en/checkout/123</em> - You should enter: <strong>/*/checkout/*</strong>.
        </p>
        <Submit disabled={invalid || submitting}>{submitButtonText}</Submit>
        <div onClick={onSkip} className='marketing-channels_skip'>Skip for now</div>
      </form>
    )
  }
}

const form = reduxForm({
  form: 'wizard-mappings',
  validate: values => {
    const errors = {}

    if (!values.mapping) {
      errors.mapping = 'Please provide correct URL for checkout'
    }

    return errors
  }
})(Mappings)

export default connect(null, {initialize})(form)



// WEBPACK FOOTER //
// ./client/components/Wizard/Mappings.js